import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import HomeHeroV3 from "@/components/marketing/visuals/HomeHeroV3";
import FullScreenButton from "@/components/marketing/visuals/FullScreenButton";

export const Route = createFileRoute("/preview/home-hero")({
  component: function Preview() {
    const [expanded, setExpanded] = useState(false);
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: expanded ? "stretch" : "center",
        justifyContent: "center",
        background: "#070E1A",
      }}>
        <FullScreenButton expanded={expanded} onToggle={() => setExpanded(e => !e)} />
        <div style={{ width: "100%", maxWidth: expanded ? "none" : undefined }}>
          <HomeHeroV3 />
        </div>
      </div>
    );
  },
});
